export type AttendanceMode = 'onsite' | 'training';

export const TRAINING_CONTRACT_TYPES = ['01', '02'] as const;

export const isTrainingContractType = (contractType?: string | null): boolean =>
  !!contractType &&
  TRAINING_CONTRACT_TYPES.includes(contractType as (typeof TRAINING_CONTRACT_TYPES)[number]);

export const hasAttendanceContractType = (contractType?: string | null): boolean =>
  !!contractType && contractType.trim() !== '';

export const resolveAttendanceModeFromContractType = (
  contractType?: string | null,
): AttendanceMode | undefined => {
  if (!hasAttendanceContractType(contractType)) {
    return undefined;
  }
  return isTrainingContractType(contractType) ? 'training' : 'onsite';
};

export const attendanceModeToRoleType = (mode: AttendanceMode): 0 | 1 =>
  mode === 'training' ? 1 : 0;

export const getAttendanceModeLabel = (mode: AttendanceMode): string =>
  mode === 'training' ? '社内研修' : '现场项目';

export const getAttendanceInputRoute = (mode: AttendanceMode): string =>
  `/general-affairs/input/${mode}`;

export const getAttendanceListRoute = (mode: AttendanceMode): string =>
  `/general-affairs/list/${mode}`;
